// Import model
import { StartContactAppointmentSendAppointmentConfirmationEmailRequest } from '../models/StartContactAppointmentSendAppointmentConfirmationEmailRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAppointmentSendAppointmentConfirmationEmailRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAppointmentSendAppointmentConfirmationEmailRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAppointmentSendAppointmentConfirmationEmailRequest instance
   */
  static deserialize(json: string): StartContactAppointmentSendAppointmentConfirmationEmailRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAppointmentSendAppointmentConfirmationEmailRequest instance
   */
  static fromObject(obj: any): StartContactAppointmentSendAppointmentConfirmationEmailRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAppointmentSendAppointmentConfirmationEmailRequest');
    }


    const instance: StartContactAppointmentSendAppointmentConfirmationEmailRequest = {
      description: obj['Description'] as string | undefined,
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
      message: obj['Message'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAppointmentSendAppointmentConfirmationEmailRequest instances
   */
  static deserializeArray(json: string): StartContactAppointmentSendAppointmentConfirmationEmailRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAppointmentSendAppointmentConfirmationEmailRequest instance to a JSON string
   */
  static serialize(instance: StartContactAppointmentSendAppointmentConfirmationEmailRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAppointmentSendAppointmentConfirmationEmailRequest instance to a plain object
   */
  static toObject(instance: StartContactAppointmentSendAppointmentConfirmationEmailRequest): any {
    return {
      'Description': instance.description,
      'UnlayerTemplateId': instance.unlayerTemplateId,
      'Message': instance.message,
    };
  }

  /**
   * Serializes an array of StartContactAppointmentSendAppointmentConfirmationEmailRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAppointmentSendAppointmentConfirmationEmailRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
